var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoDisturbOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9512_1435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 11V13H16.12L20.45 17.33C21.43 15.79 22 13.96 22 12C22 6.48 17.52 2 12 2C10.04 2 8.20998 2.57 6.66998 3.55L14.12 11H17ZM21.17 20.88L3.11998 2.83C2.72998 2.44 2.09998 2.44 1.70998 2.83C1.31998 3.22 1.31998 3.85 1.70998 4.24L3.77998 6.31C2.65998 7.93 1.99998 9.89 1.99998 12C1.99998 17.52 6.47998 22 12 22C14.11 22 16.07 21.34 17.68 20.22L19.75 22.29C20.14 22.68 20.77 22.68 21.16 22.29C21.56 21.9 21.56 21.27 21.17 20.88ZM6.99998 13V11H8.45998L10.46 13H6.99998Z",
    fill: "#303F47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9512_1435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoDisturbOff);
export default __webpack_public_path__ + "static/media/do_disturb_off.affe354a35dd063bae8973beeac828f3.svg";
export { ForwardRef as ReactComponent };